import styled from 'styled-components'

export const ModalActions = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 12px;
`
